<template>
    <div>
        <el-form ref="form" :disabled="disabled" :model="form" :rules="rule" label-width="120px" style="display: flex;flex-wrap: wrap;">
            <div class="title" style="width: 100%;margin-bottom: 10px;">{{ $t('view.公司信息') }}</div>
            <el-form-item :label="$t('view.供应商名称')" prop="declareName">
                <el-input style="width: 320px;" v-model="form.declareName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('view.供应商简称')" prop="simpleName">
                <el-input style="width: 320px;" v-model="form.simpleName"></el-input>
            </el-form-item>
            <el-form-item prop="tin" :label="form.enterpriseCategory==1?'npwp': $t('view.纳税人识别号')">
                <el-input style="width: 320px;" :disabled="form.isOne!=1" v-model="form.tin" :placeholder="$t('view.请输入')"></el-input>
            </el-form-item>
             <el-form-item prop="nickName" :label="$t('view.企业类别')">
                <el-radio-group v-model="form.enterpriseCategory" disabled style="width: 760px;">
                    <el-radio :label="0">{{ $t('view.国内供应商') }}</el-radio>
                    <el-radio :label="1">{{ $t('view.印尼供应商') }}</el-radio>
                </el-radio-group>                
            </el-form-item>
            <el-form-item :label="$t('view.投标项目')" v-if="$route.name=='EnterpriseCertification'" prop="sectionName" key="sectionName">
                <el-input style="width: 760px;" v-model="form.sectionName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('view.供应商地址')" prop="realAddress">
                <el-input style="width: 760px;" v-model="form.realAddress"></el-input>
            </el-form-item>
            <el-form-item :label="$t('view.供应商类别')" prop="category">
                <el-select style="width: 320px" clearable v-model="form.category">
                    <el-option v-for="item in supplier_category" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item  :label="$t('view.企业类型')" prop="enterpriseType">
                <el-select style="width: 320px" clearable v-model="form.enterpriseType">
                    <el-option v-for="item in enterprises_type" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                </el-select>
            </el-form-item>
            <template v-if="!['1','3','4'].includes(form.category)">
                <el-form-item :label="$t('view.生产地址')" :prop="'manufacturingAddress'">
                    <el-input style="width: 760px;" v-model="form.manufacturingAddress"></el-input>
                </el-form-item>
                <el-form-item class="line20" :label="$t('view.生产规模/产能（台套）')" prop="productionCapacity">
                    <el-input style="width: 760px;" v-model="form.productionCapacity"></el-input>
                </el-form-item>
            </template>    
            <el-form-item v-if="form.category!=2" :label="$t('view.代理商资质')" :prop="(form.category==3||form.category==4)? '':'agencyLicenseFileList'">
                <div style="flex: 1" v-if="!form.agencyLicenseFileList.length">
                    <el-upload :action="uploadFileBpm"  :limit="1"
                        :before-upload="beforeAvatarUpload"  :data="BpmData"
                        :class="{'hide': form.agencyLicenseFileList.length==1}"
                        ref="agencyLicenseFileList"
                        :headers="headers" :on-success="(res,file)=>{successList(form.agencyLicenseFileList,res,file,'agencyLicenseFileList')}"
                        :on-remove="(res,file)=>{handleRemove('agencyLicenseFileList',res,file)}">
                        <img slot="trigger" style="vertical-align: middle;width: 320px;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                    </el-upload>
                </div>
                <div v-else>
                    <File :clsoe="!disabled" :listName="'agencyLicenseFileList'" :file="form.agencyLicenseFileList[0]"></File>
                </div>
            </el-form-item>
            <el-form-item v-if="form.category!=1" :label="$t('view.产品生产资质')" prop="productionLicenseFileList">
                <div style="flex: 1" v-if="!form.productionLicenseFileList.length">
                    <el-upload :action="uploadFileBpm"  :limit="1"
                        :before-upload="beforeAvatarUpload"
                          :data="BpmData"
                        :class="{'hide': form.productionLicenseFileList.length==1}"
                        ref="productionLicenseFileList"
                        :headers="headers" :on-success="(res,file)=>{successList(form.productionLicenseFileList,res,file,'productionLicenseFileList')}"
                        :on-remove="(res,file)=>{handleRemove('productionLicenseFileList',res,file)}">
                        <img slot="trigger" style="vertical-align: middle;width: 320px" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                    </el-upload>
                </div>
                <div v-else style="display: flex;">
                    <File :clsoe="!disabled" :listName="'productionLicenseFileList'" :file="form.productionLicenseFileList[0]"></File>
                </div>
            </el-form-item>
            <el-form-item :label="$t('view.纳税性质')" prop="natureTaxpayer">
                <template>
                    <el-radio-group v-model="form.natureTaxpayer" style="width:320px">
                        <el-radio v-for="item in nature_tax_payer" :key="item.dictValue" :label="item.dictValue">{{ item.dictLabel }}</el-radio>
                    </el-radio-group>
                </template> 
            </el-form-item>
            <el-form-item :label="$t('view.实缴资本')" prop="payedCapital">
                <div style="display: flex;align-items: center;width: 320px;">
                    <el-input style="flex:1" v-model="form.payedCapital" type="number"></el-input>
                    <el-select class="unit-select" clearable v-model="form.payedCapitalUnit" :placeholder="$t('view.请选择')">
                        <el-option v-for="item in section_money_unit" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item :label="$t('view.注册地址')" prop="address">
                <el-input style="width: 320px;" v-model="form.address"></el-input>
            </el-form-item>
            <el-form-item :label="$t('view.注册资金')" prop="capital">
                <div style="display: flex;align-items: center;width: 320px;">
                    <el-input style="flex:1" v-model="form.capital" type="number"></el-input>
                    <el-select class="unit-select" clearable v-model="form.capitalUnit" :placeholder="$t('view.请选择')">
                        <el-option v-for="item in section_money_unit" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item :label="$t('view.职工人数')" prop="employeesNumber">
                <el-input @input="form.employeesNumber = form.employeesNumber.replace(/[^0-9]/g, '')" style="width: 320px;"  v-model="form.employeesNumber"></el-input>
            </el-form-item>
            <el-form-item v-if="!['1','3','4'].includes(form.category)" :label="$t('view.厂房面积')" prop="factoryArea">
                <div style="display: flex;align-items: center;width: 320px;">
                    <el-input style="flex:1" v-model="form.factoryArea"></el-input>
                    <el-select class="unit-select" clearable v-model="form.factoryAreaUnit" :placeholder="$t('view.请选择')">
                        <el-option v-for="item in sys_area_unit" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item :label="$t('view.年营业额')" prop="revenue">
                <div style="display: flex;align-items: center;width: 320px;">
                    <el-input style="flex:1" v-model="form.revenue"></el-input>
                    <el-select class="unit-select" clearable v-model="form.revenueUnit" :placeholder="$t('view.请选择')">
                        <el-option v-for="item in section_money_unit" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item :label="$t('view.公司成立日期')" prop="setUpTime">
                <el-date-picker value-format="yyyy-MM-dd" style="width: 320px;"  v-model="form.setUpTime" type="date"></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('view.三年财报')" prop="threeYearsFinancialReprotFileList">
                <div class="report-file-wrap">
                    <div class="report-file-item" v-for="(item,idx) in form.threeYearsFinancialReprotFileList" :key="idx">
                        <img v-if="!disabled" class="report-file-close" src="@/assets/BidDetails/icon-close.png" @click="removeReportFile(idx)">
                        <template v-if="isReportImage(item)">
                            <el-image class="report-file-thumb" fit="cover" :src="reportPreviewSrc(item)" :preview-src-list="[reportPreviewSrc(item)]">
                                <div slot="error" class="report-file-thumb-error" @click="handleViewFile(item.filePath,item.fileName)">
                                    <img :src="require('@/assets/BidDetails/other.png')" style="width:36px;height:36px;">
                                </div>
                            </el-image>
                            <div class="report-file-info">
                                <div class="report-file-name" :title="item.fileName">{{ item.fileName }}</div>
                                <div class="report-file-size">{{ bytesToSize(item.fileSize?item.fileSize:0) }}</div>
                            </div>
                        </template>
                        <div v-else class="report-file-main" @click="handleViewFile(item.filePath,item.fileName)">
                            <div class="report-file-thumb report-file-thumb-icon">
                                <img :src="require('@/assets/BidDetails/icon-pdf.png')" style="width:36px;height:36px;">
                            </div>
                            <div class="report-file-info">
                                <div class="report-file-name" :title="item.fileName">{{ item.fileName }}</div>
                                <div class="report-file-size">{{ bytesToSize(item.fileSize?item.fileSize:0) }}</div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!disabled && form.threeYearsFinancialReprotFileList.length<3" class="report-file-upload">
                        <el-upload :action="uploadFileBpm" :limit="3"
                        :before-upload="beforeUploadReport"
                        :on-exceed="handleExceed"
                        :show-file-list="false"
                        :data="BpmData"
                        ref="threeYearsFinancialReprotFileList"
                        :headers="headers" :on-success="successReport">
                        <img slot="trigger" style="vertical-align: middle;width: 320px;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                    </el-upload>
                    </div>
                </div>
            </el-form-item>
            <el-form-item :label="$t('view.是否经我司试用')" prop="trial">
                <template>
                    <el-radio v-model="form.trial" label="1" style="width: 145px;">是</el-radio>
                    <el-radio v-model="form.trial" label="0" style="width: 145px;">否</el-radio>
                </template>
            </el-form-item> 
            <el-form-item :label="$t('view.经营范围')" prop="businessScope">
                <el-input style="width: 760px;" v-model="form.businessScope"></el-input>
            </el-form-item>
            <el-form-item  class="line20" :label="$t('view.供应产品名称(产品类别、主营产品)')" prop="suppliedProductName">
                <el-input style="width: 760px;" v-model="form.suppliedProductName"></el-input>
            </el-form-item>
            <el-form-item  class="line20" :label="$t('view.产品出厂检测标准')" prop="testingStandards">
                <el-input style="width: 760px;" v-model="form.testingStandards"></el-input>
            </el-form-item>
            <div style="width: 100%;margin-bottom: 10px" class="title">{{ $t('view.营业信息') }}</div>
            <!-- 营业信息：单列顺序排布（营业执照 → 期限类型+营业执照有效期 → 法定代表人 → 法人代表身份证明），
                 样式全部收在 biz- 前缀的 scoped class 内，不影响其它表单区域 -->
            <div class="biz-info-wrap">
                <el-form-item :label="$t('view.营业执照')" prop="businessLicenseFileList">
                    <div class="biz-file-zone">
                        <div class="biz-file-tags">
                            <div v-for="(item,idx) in form.businessLicenseFileList" :key="idx" class="biz-file-tag">
                                <span class="biz-file-name biz-file-name-link" :title="item.fileName" @click="previewBizFile(item)">{{ item.fileName }}</span>
                                <i v-if="!(disabled&&certificationDis)" class="el-icon-close biz-file-close" @click.stop="removeBizLicenseFile(idx)"></i>
                            </div>
                        </div>
                        <el-upload v-if="!(disabled&&certificationDis)"
                            :action="uploadFileBpm"
                            :before-upload="beforeAvatarUpload"
                            :data="BpmData"
                            ref="businessLicenseFileList"
                            :headers="headers"
                            :show-file-list="false"
                            :on-success="(res,file)=>{successList(form.businessLicenseFileList,res,file,'businessLicenseFileList')}">
                            <span class="biz-upload-btn"><i class="el-icon-plus"></i>{{ $t('view.点击上传') }}</span>
                        </el-upload>
                    </div>
                </el-form-item>
                <!-- 期限类型（窄）在前，营业执照有效期（宽）在后，同一行 -->
                <div class="biz-term-row">
                    <el-form-item class="biz-term-item" :label="$t('view.期限类型')" prop="termType">
                        <el-radio-group v-model="form.termType" @change="changeTermType">
                            <el-radio :label="1">{{ $t('view.长期') }}</el-radio>
                            <el-radio :label="2">{{ $t('view.固定时间段') }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="String(form.termType) !== '1'" class="biz-valid-item" :label="$t('view.营业执照有效期')" prop="businessLicense">
                        <el-date-picker v-model="form.businessLicenseStart" class="biz-date" value-format="yyyy-MM-dd" type="date" :placeholder="$t('view.请选择开始时间')"></el-date-picker>
                        <span class="biz-date-sep">{{ $t('view.至') }}</span>
                        <el-date-picker v-model="form.businessLicenseEnd" class="biz-date" value-format="yyyy-MM-dd" type="date" :placeholder="$t('view.请选择结束时间')"></el-date-picker>
                    </el-form-item>
                </div>
                <div class="biz-legal-row">
                    <el-form-item :label="$t('view.法定代表人')" prop="legalPerson">
                        <el-input class="biz-legal-name" v-model="form.legalPerson"></el-input>
                    </el-form-item>
                    <el-form-item label-width="10px" prop="idType">
                        <el-select class="biz-legal-type" clearable v-model="form.idType">
                            <el-option v-for="item in idTypeList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label-width="10px" prop="idNo">
                        <el-input class="biz-legal-no" v-model="form.idNo"></el-input>
                    </el-form-item>
                </div>
                <el-form-item class="line20" :label="$t('view.法人代表身份证明')" prop="corporateIdCardFront">
                    <div class="biz-file-zone">
                        <div class="biz-file-tags">
                            <div v-for="(item,idx) in form.corporateIdCardFront" :key="idx" class="biz-file-tag">
                                <span class="biz-file-name biz-file-name-link" :title="item.fileName" @click="previewBizFile(item)">{{ item.fileName }}</span>
                                <i v-if="!(disabled&&certificationDis)" class="el-icon-close biz-file-close" @click.stop="removeLegalRepId()"></i>
                            </div>
                        </div>
                        <el-upload v-if="!(disabled&&certificationDis)"
                            :action="uploadFileBpm"
                            :before-upload="beforeLegalRepUpload"
                            :data="BpmData"
                            ref="legalRepId"
                            :headers="headers"
                            :show-file-list="false"
                            :on-success="successLegalRepId">
                            <span class="biz-upload-btn"><i class="el-icon-plus"></i>{{ $t('view.点击上传') }}</span>
                        </el-upload>
                        <a v-if="legalRepSampleUrl" class="sample-link biz-sample-link" :href="legalRepSampleUrl" :download="legalRepSampleName" target="_blank"><i class="el-icon-paperclip"></i>{{ $t('view.下载样例') }}</a>
                    </div>
                </el-form-item>
            </div>
            <!-- 附件图片预览弹窗：append-to-body 挂到 body，不受表单 flex 布局影响 -->
            <el-dialog :visible.sync="previewShow" :title="previewName" width="60%" append-to-body>
                <img v-if="previewUrl" :src="previewUrl" class="biz-preview-img" @click="previewShow=false">
            </el-dialog>
            <div ref="supplyTypeSection" style="width: 100%;margin-bottom: 10px;" class="title">{{ $t('view.供货类型及品牌') }}</div>
            <!-- 让他换行 给一个300 要不flex下不换行 -->
            <el-button style="min-width: 120px;margin-right: 300px;" :disabled="disabled&&certificationDis" type="primary" @click="AddType">{{ $t('view.添加') }}</el-button>
            <div style="width:880px;">
                <el-form :model="form" label-width="120px" :disabled="disabled&&certificationDis" inline>
                    <el-table  border header-row-class-name="tableHeader" :data="form.typeAndBrand" max-height="530px" style="width: 100%; margin: 20px 0 10px 0">
                        <el-table-column align="center" type="index" width="60" :label="$t('view.序号')"/>
                        <el-table-column align="center" show-overflow-tooltip prop="SupplyType" :label="$t('view.供货类型')"/>
                        <el-table-column align="center" show-overflow-tooltip :label="$t('view.品牌')">
                            <template slot-scope="scope">
                                <el-input size="mini" :disabled="false" v-model="scope.row.brand"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="150" v-if="!(disabled&&certificationDis)"  :label="$t('view.操作')">
                            <template slot-scope="scope">
                                <span class="clickText" :disabled="false"  @click="form.typeAndBrand.splice(scope.$index, 1)">{{ $t('view.删除') }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
         
            <div style="width: 100%;margin-bottom: 10px;" class="title">{{ $t('view.开户信息') }}</div>
            <el-form-item :label="$t('view.开户银行')" prop="bankName">
                <el-input style="width: 320px;" v-model="form.bankName"></el-input>
            </el-form-item>
             <el-form-item :label="$t('view.开户行号')" prop="bankNo">
                <el-input style="width: 320px;" v-model="form.bankNo"></el-input>
            </el-form-item> 
            <el-form-item :label="$t('view.账号名称')" prop="bankAccountName">
                <el-input style="width: 320px;" v-model="form.bankAccountName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('view.银行账号')" prop="bankAccountNo">
                <el-input style="width: 320px;" v-model="form.bankAccountNo"></el-input>
            </el-form-item> 
        </el-form>
        <div style="width: 100%;margin-bottom: 10px;" class="title">{{ $t('view.业务联系人') }}</div>
            <el-button style="" :disabled="disabled&&certificationDis" type="primary" @click="AddContact">{{ $t('view.添加') }}</el-button>
            <div style="width: 880px; margin: 20px 0 10px 0">
                <el-table  :data="form.authorizationContactsList" border header-row-class-name="tableHeader" max-height="530px"  >
                    <el-table-column align="center" type="index" width="60" :label="$t('view.序号')"/>
                    <el-table-column align="center" :label="$t('view.人员类型')">
                        <template slot-scope="scope">
                            <el-select :disabled="disabled&&certificationDis"  size="mini" v-model="scope.row.type" :placeholder="$t('view.请选择人员类型')" @change="(val)=>ContactTypeChange(val, scope.row)">
                                <el-option v-for="item in contactTypeOptions" :key="item.type" :label="item.typeName" :value="item.type"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" show-overflow-tooltip :label="$t('view.姓名')">
                        <template slot-scope="scope">
                            <el-input :disabled="disabled&&certificationDis" size="mini" v-model="scope.row.name"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" show-overflow-tooltip :label="$t('view.电话')">
                        <template slot-scope="scope">
                            <el-input :disabled="disabled&&certificationDis" size="mini" v-model="scope.row.phone"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" show-overflow-tooltip :label="$t('view.邮箱')">
                        <template slot-scope="scope">
                            <el-input :disabled="disabled&&certificationDis" size="mini" v-model="scope.row.email"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="150" v-if="!(disabled&&certificationDis)" :label="$t('view.操作')">
                        <template slot-scope="scope">
                            <span class="clickText" @click="form.authorizationContactsList.splice(scope.$index, 1)">{{ $t('view.删除') }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        <el-form ref="projectForm" :model="form" :disabled="certificationDis" :rules="rule" label-width="120px" style="display: flex;flex-wrap: wrap;">
            <div v-if="!certificationDis" style="width: 100%;margin-bottom: 10px;" class="title">{{ $t('view.项目信息') }}</div>
            <el-form-item  v-if="!certificationDis" :label="$t('view.项目名称：')" prop="sectionId">
                <el-select style="width: 320px" filterable  clearable v-model="form.sectionId" @change="ChoseSection">
                    <el-option v-for="item in sectionList" :key="item.sectionId" :label="item.sectionName" :value="item.sectionId"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item  v-if="!certificationDis" :label="$t('view.招标联系人')" prop="approverId" >
                <el-select style="width: 320px" clearable v-model="form.approverId" @change="ChoseUser">
                    <el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userId"></el-option>
                </el-select>            
            </el-form-item>
            <div style="width: 100%;margin-bottom: 10px;" class="title">{{ $t('view.变更申请记录') }}</div>
            <div style="width:880px;">
                <el-table  border header-row-class-name="tableHeader" :data="approvalList" max-height="530px" style="width: 100%; margin: 20px 0 10px 0">
                    <el-table-column align="center" type="index" width="60" :label="$t('view.序号')"/>
                    <el-table-column align="center" show-overflow-tooltip prop="sectionNames" :label="$t('view.项目名称')"/>
                    <el-table-column align="center" show-overflow-tooltip prop="approverName" :label="$t('view.联系人')"/>
                    <el-table-column align="center" show-overflow-tooltip prop="createTime" :label="$t('view.提交日期')"/>
                    <el-table-column align="center" show-overflow-tooltip prop="createByName" :label="$t('view.提交人')"/>
                    <el-table-column align="center" show-overflow-tooltip prop="status" :label="$t('view.状态')">
                        <template slot-scope="scope">
                            {{getStatus('supplier_type_approve_status',scope.row.status) }}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" show-overflow-tooltip prop="approverName" :label="$t('view.处理人')"/>
                    <el-table-column align="center" show-overflow-tooltip prop="updateTime" :label="$t('view.处理时间')">
                        <!-- <template slot-scope="scope">
                            {{scope.row.updateTime?scope.row.updateTime:scope.row.createTime }}
                        </template> -->
                    </el-table-column>
                    <el-table-column align="center" show-overflow-tooltip prop="SupplyType" :label="$t('view.操作')">
                        <template slot-scope="scope">
                            <span class="clickText" @click="showSupply(scope.row)">{{$t('view.查看')}}</span>
                            <span class="clickText" style="margin-right:10px" v-if="scope.row.status==3" @click="showSupply(scope.row)">{{$t('view.修改')}}</span>
                        </template>
                    </el-table-column>
                </el-table> 
            </div>
        </el-form>
        <div style="text-align: center"  v-if="!certificationDis">
            <el-button style="min-width: 120px;" @click="supplierTypeApprove" type="primary">{{ $t('view.提交') }}</el-button>
        </div>
        <!-- -->
        <div style="text-align: center"  v-if="btnShow">
            <el-button style="min-width: 120px;" @click="authorizationAuthenticate" type="primary">{{ $t('view.下一步') }}</el-button>
        </div>
        <!-- 供货类型弹窗 -->
        <el-dialog :title="$t('view.供货类型')" :visible.sync="ShowTypeAndBrand"  width="700px" >
            <el-checkbox-group v-model="checkList">
                <el-checkbox :label="item.dictValue" v-for="(item,index) in supply_type" :key="index">{{ item.dictLabel }}</el-checkbox>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="ShowTypeAndBrand = false">取 消</el-button>
                <el-button type="primary" @click="ChoseType">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 供货类型查看弹窗 -->
        <el-dialog :title="$t('view.供货类型')" :visible.sync="ShowApprovalTypeAndBrand"  width="700px" >
            <el-button style="min-width: 120px;margin-right: 300px;" v-if="supplyObj.status==3" type="primary" @click="AddType">{{ $t('view.添加') }}</el-button>
            <el-table  border header-row-class-name="tableHeader" :data="supplyObj.typeAndBrand" max-height="530px" style="width: 100%; margin: 20px 0 10px 0">
                <el-table-column align="center" type="index" width="60" :label="$t('view.序号')"/>
                <el-table-column align="center" show-overflow-tooltip prop="SupplyType" :label="$t('view.供货类型')"/>
                <el-table-column align="center" show-overflow-tooltip :label="$t('view.品牌')">
                    <template slot-scope="scope">
                        <el-input size="mini" :disabled="supplyObj.status!=3" v-model="scope.row.brand"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="150" v-if="supplyObj.status==3"  :label="$t('view.操作')">
                    <template slot-scope="scope">
                        <span class="clickText" :disabled="false"  @click="supplyObj.typeAndBrand.splice(scope.$index, 1)">{{ $t('view.删除') }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button  type="primary" v-if="supplyObj.status==3" @click="supplierTypeApprovePut()">提 交</el-button>
                <el-button @click="ShowApprovalTypeAndBrand = false;supplyObj={}">取 消</el-button>
            </span>
        </el-dialog>
    </div>
  </template>
    
<script>
import {getSectionReviewList,getAuthorization,supplierTypeApprovePut,authorizationVerify,supplierTypeApproveList,authorizationDownLoad,bpmUserList,supplierTypeApprove} from '@/api/project'
import { uploadFileBpm } from '@/utils/request'
import { getToken } from "@/utils/auth";
import { bytesToSize } from '@/utils/sczn.js'
import File from '@/components/file.vue'
import {getDicts} from '@/api/index'

  // 样例文件挂在各环境「站点根」的 /preview 下（不在 /stage-api、/prod-api 等 API 前缀内），
  // 因此从 VUE_APP_BASE_API 推导站点根 origin：
  //   dev            VUE_APP_BASE_API = http://172.16.111.11:8002/stage-api/ （绝对地址）→ 取 origin http://172.16.111.11:8002
  //   pre/staging    VUE_APP_BASE_API = /stage-api                          （相对地址）→ 返回 ''，由浏览器按当前站点自动拼接
  //   production     VUE_APP_BASE_API = /prod-api                           （相对地址）→ 返回 ''，由浏览器按当前站点自动拼接
  const getSampleSiteRoot = () => {
      const api = process.env.VUE_APP_BASE_API || ''
      const matched = api.match(/^(https?:\/\/[^/]+)/i)
      return matched ? matched[1] : ''
  }
  const SAMPLE_FILE_NAME = '持卡人身份证明材料样例.docx'
  const SAMPLE_FILE_PATH = '/preview/supplier/sample/'

  export default {
    components:{File},
    data(){
        const validateTime = (rule, value, callback) => {
            if (!(this.form.authorizationStart&&this.form.authorizationEnd)) {
                callback(new Error(this.$t('view.请选择')))
            }else if(new Date(this.form.authorizationStart).valueOf()>= new Date(this.form.authorizationEnd).valueOf()){
                callback(new Error(this.$t('view.开始时间不得大于结束时间')))
            }else if (new Date().valueOf()>=new Date(this.form.authorizationEnd).valueOf()) {
                callback(new Error(this.$t('view.大于当前系统时间')))
            } else {
                callback()
            }

        }
        const validateTime1 = (rule, value, callback) => {
            // 期限类型为「长期」(termType=1) 时无需选择营业执照有效期，直接放行
            if (String(this.form.termType) === '1') {
                callback()
                return
            }
            if (!(this.form.businessLicenseStart&&this.form.businessLicenseEnd)) {
                callback(new Error(this.$t('view.请选择')))
            }else if(new Date(this.form.businessLicenseStart).valueOf()>= new Date(this.form.businessLicenseEnd).valueOf()){
                callback(new Error(this.$t('view.开始时间不得大于结束时间')))
            }else if (new Date().valueOf()>=new Date(this.form.businessLicenseEnd).valueOf()) {
                callback(new Error(this.$t('view.大于当前系统时间')))
            } else {
                callback()
            }
        }
        const validateTaxpayerNo = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('view.请输入')))
            } 
            // else if ((!taxpayerNo.test(value))) {
            //     callback(new Error(this.$t('view.格式有误')))
            // } 
            else {
                callback()
            }
        }
      return{
        certificationDis:true,
        ShowTypeAndBrand:false, //供货类型及品牌添加弹窗
        supplyObj:{} ,
        supply_type:[],//供货类型
        checkList:[],//
        contactTypeOptions:[//业务联系人-人员类型（三种默认类型）
            { typeName: this.$t('view.单位管理人'), type: 1 },
            { typeName: this.$t('view.合同签订人'), type: 2 },
            { typeName: this.$t('view.采购业务员'), type: 3 }
        ],
        form:{
            businessLicenseFileList:[],
            termType:2,//营业执照期限类型：1=长期（不校验有效期，且隐藏有效期） / 2=固定时间段
            agencyLicenseFileList:[],
            productionLicenseFileList:[],
            threeYearsFinancialReprotFileList:[],
            corporateIdCardFront:[],
            corporateIdCardOpposite:[],
            authorizationFileList:[],
            payedCapitalUnit:'',//实缴资本单位（section_money_unit）
            capitalUnit:'',//注册资金单位（section_money_unit）
            revenueUnit:'',//年营业额单位（section_money_unit）
            factoryAreaUnit:'',//厂房面积单位（sys_area_unit）
        },
        // 法人代表身份证明样例：地址按当前环境自动拼接（站点根 + /preview/supplier/sample/文件名）
        // 若某环境样例地址特殊，在该环境对应的 .env.[mode] 中加一行 VUE_APP_SAMPLE_URL 即可覆盖，代码无需改动
        legalRepSampleUrl: process.env.VUE_APP_SAMPLE_URL || (getSampleSiteRoot() + SAMPLE_FILE_PATH + SAMPLE_FILE_NAME),
        legalRepSampleName: SAMPLE_FILE_NAME,
        uploadFileBpm,
        url:'',
        previewShow:false,//附件图片预览弹窗显隐
        previewUrl:'',//附件图片预览地址
        previewName:'',//附件图片预览标题
        idTypeList:[{dictValue:'1' ,dictLabel:this.$t('view.身份证')},{dictValue:'2' ,dictLabel:this.$t('view.护照')}],
        BpmData:{type:'qyrzlc'},
        locale: localStorage.getItem('locale')||'zh',
        headers: {
            Authorization:getToken(),
        },
        rule: {
            tin:[{ required: true, validator:validateTaxpayerNo, trigger: "change" },],
            setUpTime:[{ required: true, message: this.$t('view.请选择'), trigger: "change" }],
            bankName: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            sectionName:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            bankNo: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            bankAccountName: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            bankAccountNo: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            declareName: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            simpleName: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            realAddress: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            category: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            enterpriseType: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            manufacturingAddress: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            agencyLicenseFileList: [{ required: true, message: this.$t('view.请上传'), trigger: "change" }],
            natureTaxpayer: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            payedCapital: [{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            threeYearsFinancialReprotFileList:[{ required: true, message: this.$t('view.请上传'), trigger: "change" }],
            suppliedProductName:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            businessLicenseFileList:[{ required: true, message: this.$t('view.请上传'), trigger: "change" }],
            termType:[{ required: true, message: this.$t('view.请选择'), trigger: "change" }],
            businessLicense:[{ required: true, validator: validateTime1 , trigger: "change" }],
            isLegalRepresentative:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            mobile:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            email:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            authorizationFileList:[{ required: true, message: this.$t('view.请上传'), trigger: "change" }],
            authorizationList:[{ required: true, validator: validateTime  ,trigger: "change" }],
            legalPerson:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            idNo:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            idType:[{ required: true, message: this.$t('view.请选择'), trigger: "change" }],
            productionLicenseFileList:[{ required: true, message: this.$t('view.请上传'), trigger: "change" }],
            businessScope:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            productionCapacity:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            address:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            capital:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            employeesNumber:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            factoryArea:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            revenue:[{ required: true, message: this.$t('view.请输入'), trigger: "change" }],
            corporateIdCardFront:[{ required: true, message: this.$t('view.请上传'), trigger: "change" }],
            sectionId:[{ required: true, message: this.$t('view.请选择'), trigger: "change" }], 
            approverId:[{ required: true, message: this.$t('view.请选择'), trigger: "change" }],  
        },
        reupload:false,//资质上传 重新上传的判断
        details:{},
        supplier_category :[],//供应商类别
        enterprises_type:[],//企业类型
        nature_tax_payer:[],//纳税性质
        section_money_unit:[],//金额单位（实缴资本/注册资金/年营业额）
        sys_area_unit:[],//面积单位（厂房面积）
        supplier_type_approve_status:[],// 供货类型及品牌审批记录状态
        sectionList:[],
        userList:[],
        approvalList:[],//供货类型及品牌审批记录
        ShowApprovalTypeAndBrand:false, 
        TypeList:[]
      }
    },
    props:{
        btnShow:{
            type:Boolean,
            default:false
        },
        ChildForm: {
            type: Object,
            default:{}
        },
        disabled:{
            type:Boolean,
            default:false
        }
    },
    watch:{
        ChildForm: {
            handler(val,oldVal) {
                this.form=val
                if(this.$route.query.sectionId){
                    
                    this.$set(this.form,'sectionNames',this.$route.query.sectionName)
                }
                // 营业执照期限类型：历史数据无该字段时按「固定时间段」(2) 回显；有值统一转数值，保证 radio 能选中
                if(this.form.termType === undefined||this.form.termType === null||this.form.termType === ''){
                    this.$set(this.form,'termType',2)
                }else if(typeof this.form.termType !== 'number'){
                    this.$set(this.form,'termType',Number(this.form.termType))
                }
                // 业务联系人：type 统一转数值，保证 el-select 能匹配下拉选项（后端可能回传字符串）
                (this.form.authorizationContactsList||[]).forEach(item => {
                    if(item.type !== undefined && item.type !== null && item.type !== '' && typeof item.type !== 'number'){
                        this.$set(item,'type',Number(item.type))
                    }
                })
                if(this.form.isTypeAndBrandReview==1&&this.$route.query.sectionId)
                this.certificationDis=false
                this.bpmUserList()
                this.checkList= this.form.typeAndBrand.map(user => user.dictValue);
                this.$nextTick(function(){ 
                    this.$refs.form.clearValidate()
                    if (this.$route.query.projectMaterialType)
                    this.scrollSupplyTypeSection()
                })
            },
        },
    },
    created(){
        this.getDicts('supplier_category')
        this.getDicts('enterprises_type')
        this.getDicts('nature_tax_payer')
        this.getDicts('section_money_unit')
        this.getDicts('sys_area_unit')
        this.getDicts('supply_type')
        this.getDicts('supplier_type_approve_status')
        this.supplierTypeApproveList()
        this.signupList()
    },
    methods:{
        scrollSupplyTypeSection(){
                this.$refs.supplyTypeSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
        },
        // 营业执照期限类型切换：选择「长期」(termType=1) 时清空有效期（提交空值，且不参与必填校验）
        changeTermType(val){
            if(String(val) === '1'){
                this.form.businessLicenseStart = ''
                this.form.businessLicenseEnd = ''
            }
            this.$nextTick(() => {
                if(this.$refs.form) this.$refs.form.clearValidate(['businessLicense'])
            })
        },
        validateForm() {
            return new Promise((resolve) => {
                this.$refs.form.validate((valid) => {
                    resolve(valid);
                });
            });
        },
        showSupply(item){ 
            this.supplyObj={}
            item= JSON.parse(JSON.stringify(item))
            item.typeAndBrand =JSON.parse(item.typeAndBrand)
            this.supplyObj=item
            this.ShowApprovalTypeAndBrand=true
        },
        supplierTypeApproveList(){
            supplierTypeApproveList({createBy:this.$store.getters.userId}).then(res=>{
                this.approvalList=res.rows
            })
        },
        signupList(){
            getSectionReviewList().then(res=>{
                this.sectionList=res.data
                if(this.$route.query.sectionId)
                this.$set(this.form,'sectionId',(this.$route.query.sectionId+''))
            })
        },
        bpmUserList(){
            bpmUserList({pageNum: 1,pageSize: 100}).then(res=>{
                this.userList=res.rows
                if(this.$route.query.userName){
                    const targetObj = this.userList.find(item => item.userName == this.$route.query.userName)
                    this.$set(this.form,'approverId',targetObj.userId)
                    this.$set(this.form,'approverName',this.$route.query.userName)
                }
            })
        },
        ChoseSection(e){
            const targetObj = this.sectionList.find(item => item.sectionId == e);
            console.log('132',targetObj)
            this.$set(this.form,'sectionNames',targetObj.sectionName)
            this.$set(this.form,'approverName',targetObj.businessContacts)
            this.$set(this.form,'approverId',targetObj.createBy)

        },
        ChoseUser(e){
            const targetObj = this.userList.find(item => item.userId == e);
            this.$set(this.form,'approverName',targetObj.userName)
        },
        AddType(){
            this.checkList= this.supplyObj.id? this.supplyObj.typeAndBrand.map(user => user.dictValue): this.form.typeAndBrand.map(user => user.dictValue);
            this.ShowTypeAndBrand=true
        },
        // 业务联系人：新增一行
        AddContact(){
            this.form.authorizationContactsList.push({ typeName:'', type:null, name:'', phone:'', email:'' });
        },
        // 业务联系人：人员类型选中后同步 typeName（保存时字段与历史数据保持一致）
        ContactTypeChange(val, row){
            const target = this.contactTypeOptions.find(item => item.type === val);
            if(target){ row.typeName = target.typeName; }
        },
        ChoseType(){
            const result2 = []; 
            for (const item of this.supply_type) {
                if (this.checkList.includes(item.dictValue)) {
                    result2.push({
                        brand:'', 
                        SupplyType:item.dictLabel,
                        dictValue:item.dictValue
                    });
                }
            }
            const mergedMap = new Map(result2.map(item => [item.dictValue, item]));
            if(this.supplyObj.id){
                this.supplyObj.typeAndBrand.forEach(item => {
                    mergedMap.set(item.dictValue, item);
                });
                this.supplyObj.typeAndBrand = Array.from(mergedMap.values());
            }else{
                this.form.typeAndBrand.forEach(item => {
                    mergedMap.set(item.dictValue, item);
                });
                this.form.typeAndBrand = Array.from(mergedMap.values());
            }
            this.ShowTypeAndBrand = false
        },
        elFormErrorScrollIntoView() {
        // 获取第一个校验错误的元素
            let isError = document.querySelectorAll('.el-form-item__error')[0]
            if(isError){
                // 滚动到错误元素对应位置
                isError.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                })
            }
        },
         // 重新上传
        reuploadClick(list){
            this.$set(this.form,list,[])
            // 法人身份证合并上传：正面/反面共用同一份，删除时同步清空两个字段
            if(list === 'corporateIdCardFront' || list === 'corporateIdCardOpposite'){
                this.form.corporateIdCardFront = []
                this.form.corporateIdCardOpposite = []
            }
            this.$forceUpdate()
        },
        supplierTypeApprovePut(){
            if(!this.supplyObj.typeAndBrand.length){
                this.$message.error(this.$t('view.请添加供货类型及品牌信息'));
                return
            }
            for(let i=0;i<this.supplyObj.typeAndBrand.length;i++){
                if(!this.supplyObj.typeAndBrand[i].brand){
                    this.$message.error(this.$t('view.请输入')+this.$t('view.品牌'));
                    return
                }
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data=JSON.parse(JSON.stringify(this.supplyObj))
            data.typeAndBrand=JSON.stringify(data.typeAndBrand)
            data.status=1
            supplierTypeApprovePut(data).then(res=>{ 
                if (res.code == 200){
                    loading.close();
                    setTimeout(function() {
                        location.reload()
                    }, 1000);
                }
            })
        },
        supplierTypeApprove(){
            this.$refs.projectForm.validate((a) => {
                if (a) {
                    if(!this.form.typeAndBrand.length){
                        this.$message.error(this.$t('view.请添加供货类型及品牌信息'));
                        return
                    }
                    for(let i=0;i<this.form.typeAndBrand.length;i++){
                        if(!this.form.typeAndBrand[i].brand){
                            this.$message.error(this.$t('view.请输入')+this.$t('view.品牌'));
                            return
                        }
                    }
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let data=JSON.parse(JSON.stringify(this.form))
                    supplierTypeApprove({
                        supplierName:data.declareName,
                        approverId:data.approverId,
                        approverName:data.approverName,
                        typeAndBrand:JSON.stringify(data.typeAndBrand),
                        sectionId:data.sectionId,
                        sectionNames:data.sectionNames,
                    }).then(res=>{ 
                        if (res.code == 200){
                            // loading.close();
                            // setTimeout(function() {
                                location.reload()
                            // }, 2000);
                        }
                    })
                    // if(this.form.authorizationList&&this.form.authorizationList.length){
                    //     this.form.authorizationEnd=this.form.authorizationList[1]
                    //     this.form.authorizationStart=this.form.authorizationList[0]
                    // }
                   
                }else {
                    // 数据校验失败
                    // 使用$nextTick的原因是，错误提示的元素是在视图更新后出现的，不使用$nextTick获取元素是undefined
                    this.$nextTick(() => {
                        this.elFormErrorScrollIntoView()
                    })
                }
            });
        },
        authorizationAuthenticate(){
            this.$refs.form.validate((a) => {
                if (a) {
                    if(!this.form.typeAndBrand.length){
                        this.$message.error(this.$t('view.请添加供货类型及品牌信息'));
                        return
                    }
                    for(let i=0;i<this.form.typeAndBrand.length;i++){
                        if(!this.form.typeAndBrand[i].brand){
                            this.$message.error(this.$t('view.请输入')+this.$t('view.品牌'));
                            return
                        }
                    }
                    if(!this.form.authorizationContactsList || !this.form.authorizationContactsList.length){
                        this.$message.error(this.$t('view.请添加业务联系人'));
                        return
                    }
                    let list =[{val:'type',tip:this.$t('view.人员类型'),pre:this.$t('view.请选择')},{val:'name',tip:this.$t('view.姓名'),pre:this.$t('view.请输入')},{val:'phone',tip:this.$t('view.电话'),pre:this.$t('view.请输入')},{val:'email',tip:this.$t('view.邮箱'),pre:this.$t('view.请输入')}]
                    for(let i=0;i<this.form.authorizationContactsList.length;i++){
                        const row = this.form.authorizationContactsList[i];
                        for(let j=0;j<list.length;j++){
                            if(!row[list[j].val] && row[list[j].val] !== 0){
                                this.$message.error(list[j].pre + this.$t('view.业务联系人') + '(' + (i+1) + ')' + list[j].tip);
                                return
                            }
                        }
                    }
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.$emit('nextStep',this.form)
                    loading.close()
                    // if(this.form.authorizationList&&this.form.authorizationList.length){
                    //     this.form.authorizationEnd=this.form.authorizationList[1]
                    //     this.form.authorizationStart=this.form.authorizationList[0]
                    // }
                   
                }else {
                    // 数据校验失败
                    // 使用$nextTick的原因是，错误提示的元素是在视图更新后出现的，不使用$nextTick获取元素是undefined
                    this.$nextTick(() => {
                        this.elFormErrorScrollIntoView()
                    })
                }
            });
        },
        getDicts(type){
            getDicts(type).then(res=>{
                res.data.map(item=>{
                    item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
                })
                this[type]=res.data
            })
        },
      // 附件查看与下载：PDF 新窗口预览，其它格式下载
      handleViewFile(filePath, fileName) {
        const ext = String(fileName || filePath).split('?')[0].split('.').pop().toLowerCase()
        if (ext === 'pdf') {
            window.open(filePath, "_blank");
        } else {
            const eLink = document.createElement("a");
            eLink.download = fileName;
            eLink.style.display = "none";
            eLink.href = filePath;
            document.body.appendChild(eLink);
            eLink.click();
            eLink.remove()
        }
      },
      // 附件预览：图片弹大图预览层，PDF 新窗口预览，Word/Excel 等浏览器无法内联预览的格式转下载
      previewBizFile(item) {
        if (!item) return
        const filePath = item.filePath || item.url
        const fileName = item.fileName || ''
        if (!filePath) {
            this.$message.warning(this.$t('view.文件地址不存在'))
            return
        }
        // 图片：弹出图片预览窗
        if (this.isReportImage(item)) {
            this.previewUrl = filePath
            this.previewName = fileName
            this.previewShow = true
            return
        }        // PDF：浏览器可直接在新窗口内预览
        const ext = String(fileName || filePath).split('?')[0].split('.').pop().toLowerCase()
        if (ext === 'pdf') {
            window.open(filePath, "_blank")
            return
        }
        // 其它格式：浏览器不支持内联预览，转为下载并提示
        const eLink = document.createElement("a")
        eLink.download = fileName
        eLink.style.display = "none"
        eLink.href = filePath
        document.body.appendChild(eLink)
        eLink.click()
        eLink.remove()
        this.$message.info(this.$t('view.该格式不支持在线预览，已下载文件'))
      },
      // 三年财报：文件大小格式化
      bytesToSize,
      // 三年财报：是否图片文件（兼容后端 fileName 不带扩展名的情况，回退用 filePath/url 判断）
      isReportImage(item){
        const exts = ['jpg','jpeg','png','gif','bmp','webp'];
        const pick = (s) => String(s || '').split('?')[0].split('.').pop().toLowerCase();
        return exts.indexOf(pick(item.fileName)) > -1 || exts.indexOf(pick(item.filePath || item.url)) > -1;
      },
      // 三年财报：图片预览地址（回显时后端给的 filePath 已是完整地址，直接展示；本次新上传的用本地 blob 预览）
      reportPreviewSrc(item){
        return item.localUrl || item.filePath || item.url;
      },
      beforeAvatarUpload(file){
          // image/png zip rar pdf
        if((!file.type.includes('pdf'))&&(!file.type.includes('image'))&&(!file.type.includes('zip'))&&(!file.type.includes('application/x-compressed'))){
            this.$message.error(this.$t('view.格式有误'));
            return false
        }
        return true
      },
      // 三年财报：仅允许图片或PDF
      beforeUploadReport(file){
        if((!file.type.includes('pdf'))&&(!file.type.includes('image'))){
            this.$message.error(this.$t('view.格式有误'));
            return false
        }
        return true
      },
      // 三年财报：超过最多上传数量
      handleExceed(){
        this.$message.error(this.$t('view.最多上传3个文件'));
      },
      // 三年财报：上传成功（localUrl 为本地 blob 地址，缩略图优先用它，避免服务端 URL 不可达导致加载失败）
      successReport(res, file){
        if(res.code != 200){
          this.$refs.threeYearsFinancialReprotFileList.clearFiles();
          return
        }
        const data = file.response.data;
        // el-upload 仅在 picture-card/picture 模式下生成 file.url，text 模式需自行创建 blob 预览地址
        let localUrl = '';
        if(file.raw && this.isReportImage({fileName: data.newFileName})){
          try{ localUrl = URL.createObjectURL(file.raw); }catch(e){ localUrl = ''; }
        }
        this.form.threeYearsFinancialReprotFileList.push({
          fileName: data.newFileName,
          filePath: data.url,
          url: data.url,
          localUrl: localUrl,
          type: data.newFileName.split('.').pop(),
          fileSize: file.size,
          bpmFileId: data.bpmFileId
        })
      },
      // 三年财报：按项删除，并同步 el-upload 内部记录（保证 :limit 准确）
      removeReportFile(index){
        const removed = this.form.threeYearsFinancialReprotFileList.splice(index,1)
        const uploadRef = this.$refs.threeYearsFinancialReprotFileList
        if(uploadRef && uploadRef.uploadFiles){
            const removedUrl = removed[0] && removed[0].filePath
            const idx = uploadRef.uploadFiles.findIndex(f => f.response && f.response.data && f.response.data.url === removedUrl)
            if(idx > -1){
                uploadRef.uploadFiles.splice(idx,1)
            }
        }
      },
      // 删除
      handleRemove(list, file, fileList) {
        this.$set(this.form,list,[])
        fileList.map(item=>{
            this.form[list].push({
                fileName:item.response.originalFilename,
                filePath:item.response.fileName,
                url: item.response.url, 
            })
        })
      },
      downloadTemplate(){
            authorizationDownLoad().then(res=>{
                const blob = new Blob([res]);
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = this.$t('view.投标授权委托书模板.docx');
                link.click();
            })
        },
      // 上传文件
      successList(list,res,file,ref){
          // 上传失败
          if(res.code!=200){
            this.$refs[ref].clearFiles();
            return
          }
          if(!list)
          list=[]
          list.push({
              fileName:file.response.data.newFileName,
              filePath:file.response.data.url,
              url: file.response.data.url, 
              type:file.response.data.newFileName.split(".").pop(),
              fileSize:file.size,
              bpmFileId:file.response.data.bpmFileId

          })
      },
      // 法人身份证：单次上传，结果同时写入正反面两个字段（同一份，兼容未改的后端）
      successLegalRepId(res, file){
          if(res.code != 200){
              if(this.$refs.legalRepId) this.$refs.legalRepId.clearFiles();
              return
          }
          const data = file.response.data;
          const item = {
              fileName: data.newFileName,
              filePath: data.url,
              url: data.url,
              type: data.newFileName.split('.').pop(),
              fileSize: file.size,
              bpmFileId: data.bpmFileId
          };
          this.form.corporateIdCardFront = [item];
          this.form.corporateIdCardOpposite = [item];
      },
        // 法人身份证：删除时清空两个字段并重置上传组件
        removeLegalRepId(){
            this.form.corporateIdCardFront = [];
            this.form.corporateIdCardOpposite = [];
            if(this.$refs.legalRepId) this.$refs.legalRepId.clearFiles();
        },
        // 营业执照：按项删除附件（支持多附件展示），并同步上传组件内部列表
        removeBizLicenseFile(index){
            const removed = this.form.businessLicenseFileList.splice(index,1);
            const uploadRef = this.$refs.businessLicenseFileList;
            if(uploadRef && uploadRef.uploadFiles){
                const removedUrl = removed[0] && removed[0].filePath;
                const idx = uploadRef.uploadFiles.findIndex(f => f.response && f.response.data && f.response.data.url === removedUrl);
                if(idx > -1){ uploadRef.uploadFiles.splice(idx,1); }
            }
        },
      // 法人身份证：允许 图片/PDF/Word（样例为 docx，需支持上传）
      beforeLegalRepUpload(file){
          const ok = file.type.includes('image') || file.type.includes('pdf') ||
              file.type.includes('msword') || file.type.includes('officedocument') ||
              /\.(doc|docx)$/i.test(file.name);
          if(!ok){
              this.$message.error(this.$t('view.格式有误'));
              return false;
          }
          return true;
      },
 
      
    }
};
  </script>
  <style>
  .line20 .el-form-item__label{
    line-height: 20px !important;
  }
  </style>
  <style lang="scss" scoped>
  ::v-deep.hide .el-upload--picture-card {
    display: none;
  }
  ::v-deep.hide .el-upload--text{
      display: none;
  }
  .annexList{
      display: flex;
      margin-bottom: 20px;
      font-size: 14px;
      color: #303133;
      div:first-child{
          color: #909399;        
      }
  }
  .title{
      font-size: 16px;
      font-weight: 600;
      color: #333333;
  }
  /* 金额/面积单位下拉（紧跟数值输入框，固定宽度不参与伸缩） */
  .unit-select{
      flex-shrink: 0;
      width: 120px;
      margin-left: 8px;
  }
  /* 法人代表身份证明：下载样例链接 */
  .sample-link{
      display: inline-block;
      margin-bottom: 8px;
      color: #409EFF;
      font-size: 14px;
      text-decoration: none;
      cursor: pointer;
  }
  .sample-link:hover{
      text-decoration: underline;
  }
  /* 三年财报文件卡片 */
  .report-file-wrap{
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      gap: 14px;
      flex: 1;
  }
  .report-file-item{
      position: relative;
      display: flex;
      align-items: center;
      width: 300px;
      padding: 10px;
      background: #F2F6FC;
      border-radius: 4px;
      box-sizing: border-box;
  }
  .report-file-close{
      position: absolute;
      right: -6px;
      top: -6px;
      width: 16px;
      height: 16px;
      cursor: pointer;
      z-index: 2;
  }
  .report-file-main{
      display: flex;
      align-items: center;
      width: 100%;
      cursor: pointer;
  }
  .report-file-thumb{
      width: 56px;
      height: 56px;
      border-radius: 4px;
      background: #FFFFFF;
      flex-shrink: 0;
      overflow: hidden;
  }
  .report-file-thumb-icon,
  .report-file-thumb-error{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
  }
  .report-file-info{
      flex: 1;
      min-width: 0;
      margin-left: 10px;
  }
  .report-file-name{
      font-size: 14px;
      color: #606266;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
  }
  .report-file-size{
      margin-top: 6px;
      font-size: 12px;
      color: #999999;
  }
  /* ===== 营业信息区块（仅在 .biz-info-wrap 内生效，不影响其它表单区域） ===== */
  .biz-info-wrap{
      display: flex;
      flex-direction: column;
      width: 100%;
  }
  /* 期限类型（窄）+ 营业执照有效期（宽）同一行：前者内容自适应，后者撑满剩余宽度 */
  .biz-term-row{
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      width: 100%;
  }
  .biz-term-item{
      flex: 0 0 auto;
  }
  .biz-valid-item{
      flex: 1 1 0;
      min-width: 420px;
      margin-left: 20px;
  }
  /* 附件标签 + 紧凑上传按钮 */
  .biz-file-zone{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;
  }
  .biz-file-tags{
      display: flex;
      flex-direction: column;
      gap: 8px;
      min-width: 0;
  }
  .biz-file-tag{
      display: flex;
      align-items: center;
      width: 210px;
      height: 28px;
      padding: 0 8px;
      background: #FEF0F0;
      border-radius: 2px;
      box-sizing: border-box;
  }
  .biz-file-name{
      flex: 1;
      min-width: 0;
      font-size: 13px;
      color: #F56C6C;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
  }
  /* 附件名可点击预览：鼠标手型 + hover 下划线提示 */
  .biz-file-name-link{
      cursor: pointer;
  }
  .biz-file-name-link:hover{
      text-decoration: underline;
  }
  /* 预览弹窗内的图片：自适应，超长图限制高度，点击图片关闭弹窗 */
  .biz-preview-img{
      display: block;
      max-width: 100%;
      max-height: 72vh;
      margin: 0 auto;
      cursor: zoom-out;
  }
  .biz-file-close{
      flex-shrink: 0;
      margin-left: 6px;
      font-size: 12px;
      color: #F56C6C;
      cursor: pointer;
  }
  .biz-upload-btn{
      display: inline-flex;
      align-items: center;
      height: 28px;
      padding: 0 10px;
      font-size: 13px;
      color: #606266;
      white-space: nowrap;
      border: 1px dashed #DCDFE6;
      border-radius: 3px;
      cursor: pointer;
  }
  .biz-upload-btn i{
      margin-right: 4px;
      color: #409EFF;
  }
  .biz-upload-btn:hover{
      color: #409EFF;
      border-color: #409EFF;
  }
  /* 有效期（.el-date-editor.el-input 默认 220px，提高一级选择器优先级覆盖它） */
  .biz-date.el-date-editor{
      width: 150px;
  }
  .biz-date-sep{
      margin: 0 8px;
      color: #606266;
  }
  /* 法定代表人 + 证件类型 + 证件号（同一行，窄屏自动换行） */
  .biz-legal-row{
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
  }
  .biz-legal-name{
      width: 130px;
  }
  .biz-legal-type{
      width: 100px;
  }
  .biz-legal-no{
      width: 190px;
  }
  .biz-sample-link{
      margin-bottom: 8px;
  }
  .biz-sample-link i{
      margin-right: 4px;
  }
  </style>
   